export const soccerRules = [
  {
    title: 'Field Dimensions',
    type: 'info',
    diagram: {
      label: 'Field Size',
      value: '100-130 yds'
    },
    points: [
      'Length: 100-130 yards (90-120 meters)',
      'Width: 50-100 yards (45-90 meters)',
      'Goal size: 8 yards wide × 8 feet tall',
      'FIFA standard: 110-120 yards × 70-80 yards'
    ],
    keyFact: 'Soccer fields can vary significantly in size, unlike most other sports!'
  },
  {
    title: 'Team Composition',
    type: 'info',
    diagram: {
      label: 'Players per Team',
      value: '11'
    },
    points: [
      '11 players per team on field (including goalkeeper)',
      'Unlimited substitutions in most youth leagues',
      '3-5 substitutions allowed in professional matches',
      'Minimum 7 players required to continue match'
    ],
    keyFact: 'A match must be abandoned if a team has fewer than 7 players!'
  },
  {
    title: 'Game Duration',
    type: 'info',
    diagram: {
      label: 'Match Length',
      value: '90 minutes'
    },
    points: [
      'Two 45-minute halves',
      '15-minute halftime break',
      'Stoppage time added by referee',
      'Extra time (30 minutes) in knockout matches if tied'
    ],
    keyFact: 'The longest professional match ever played lasted over 3.5 hours with extra time and penalties!'
  },
  {
    title: 'Offside Rule',
    type: 'dont',
    points: [
      'Player is offside if ahead of second-last opponent when ball is played',
      'Only applies in opponent\'s half of field',
      'Not offside from goal kicks, throw-ins, or corner kicks',
      'Must be interfering with play to be called offside'
    ],
    keyFact: 'The offside rule is the most debated and frequently updated rule in soccer!'
  }
];

export const soccerGoverningBodies = [
  {
    name: 'FIFA',
    description: 'Fédération Internationale de Football Association - International governing body with 211 member associations. Organizes the World Cup and sets global rules.',
    website: 'https://www.fifa.com'
  },
  {
    name: 'U.S. Soccer',
    description: 'Official governing body for soccer in the United States, overseeing national teams, professional leagues, and youth development.',
    website: 'https://www.ussoccer.com'
  }
];

export const soccerTournaments = [
  {
    name: 'FIFA World Cup',
    description: 'The most prestigious tournament in soccer, held every 4 years with 32 nations competing (expanding to 48 in 2026).',
    website: 'https://www.fifa.com/tournaments/mens/worldcup'
  },
  {
    name: 'Major League Soccer (MLS)',
    description: 'Top professional soccer league in the U.S. and Canada with 29 teams and growing.',
    website: 'https://www.mlssoccer.com'
  },
  {
    name: 'UEFA Champions League',
    description: 'Europe\'s premier club competition featuring the best teams from European leagues.',
    website: 'https://www.uefa.com/uefachampionsleague/'
  },
  {
    name: 'Copa América',
    description: 'South American continental championship, the oldest international continental football competition.',
    website: 'https://www.conmebol.com/copaamerica'
  }
];

export const soccerResources = [
  {
    name: 'U.S. Soccer Events',
    website: 'https://www.ussoccer.com/events'
  },
  {
    name: 'MLS Schedule',
    website: 'https://www.mlssoccer.com/schedule'
  },
  {
    name: 'FIFA Rankings',
    website: 'https://www.fifa.com/fifa-world-ranking'
  }
];
